import { Component, inject } from '@angular/core';
import { TruckCategoryService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TruckCategoryCreateDto,
  TruckCategoryDto,
  TruckCategoryExcelDownloadDto,
  TruckCategoryUpdateDto,
} from '../proxy/general/dtos/truck-category';
import { TRUCKCATEGORY_CONFIG, TRUCKCATEGORY_FIELDS } from './truck-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-truck-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TruckCategoryService, ConfirmationService],
  templateUrl: './truck-category.html',
  styleUrl: './truck-category.scss',
})
export class TruckCategory extends BaseCrudComponent<
  TruckCategoryDto,
  TruckCategoryCreateDto,
  TruckCategoryUpdateDto,
  TruckCategoryExcelDownloadDto
> {
  service = inject(TruckCategoryService);
  config = TRUCKCATEGORY_CONFIG;
  fields = TRUCKCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: TruckCategoryDto): TruckCategoryUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TruckCategory';
  }
}
